import { type AxiosInstance } from 'axios'
import authApis from '~/apis/auth'
import permissionsApis from '~/apis/permissions'
import tiersApis from '~/apis/tiers'
import tenantsApis from '~/apis/tenants'
import metricsApis from '~/apis/metrics'
import efdbApis from '~/apis/efdb'
import companyEmissionsApis from '~/apis/company-emissions'
import emissionTrackerApis from '~/apis/emission-tracker'
import companiesApis from '~/apis/companies'
import unitsApis from '~/apis/units'
import questionsApis from '~/apis/questions'
import allTenantsApis from '~/apis/all-tenants'
import assetsApis from '~/apis/assets'
import esgMetricsApis from '~/apis/esg-metrics'
import abatementsApi from '~/apis/abatements'
import backstageApi from '~/apis/backstage'
import pollutantsApi from '~/apis/pollutants'
import featureNotificationsApis from '~/apis/feature-notifications'
import reportingApis from '~/apis/reporting'
import profileApis from '~/apis/profile'
import sftpApis from '~/apis/sftp'
import invitationApis from '~/apis/invitations'
import storeApis from '~/apis/store'
import measurementsApis from '~/apis/measurements'
import industriesApis from '~/apis/industries'
import subscriptionApis from '~/apis/subscriptions'
import progressTrackerApis from '~/apis/progress-tracker'
import usersApi from '~/apis/users'
import ghgMetricsApis from '~/apis/ghg-metrics'

import southpoleApis from '~/apis/thirdparty/southpole'

export default defineNuxtPlugin({
  name: 'apis',

  dependsOn: ['store', 'axios', 'toast'],

  setup({ $axios, $config, $store, $toast }) {
    // Typing $axios instead of using it directly
    const _axios = $axios as AxiosInstance

    if (!_axios) return

    return {
      provide: {
        apis: {
          auth: authApis(_axios, $store),
          permissions: permissionsApis(_axios),
          tiers: tiersApis(_axios),
          tenants: tenantsApis(_axios, $config.public),
          metrics: metricsApis(_axios),
          efdb: efdbApis(_axios),
          companyEmissions: companyEmissionsApis(_axios),
          emissionTracker: emissionTrackerApis(_axios),
          companies: companiesApis(_axios),
          units: unitsApis(_axios),
          questions: questionsApis(_axios),
          allTenants: allTenantsApis(_axios),
          assets: assetsApis(_axios),
          esgMetrics: esgMetricsApis(_axios, $store),
          abatements: abatementsApi(_axios),
          featureNotifications: featureNotificationsApis(_axios),
          reporting: reportingApis(_axios),
          profile: profileApis(_axios),
          sftp: sftpApis(_axios),
          invitations: invitationApis(_axios),
          store: storeApis(_axios),
          southPole: southpoleApis($config.public, $store, $toast),
          backstage: backstageApi(_axios),
          pollutants: pollutantsApi(_axios),
          measurements: measurementsApis(_axios),
          industries: industriesApis(_axios),
          subscriptions: subscriptionApis(_axios),
          progressTracker: progressTrackerApis(_axios),
          users: usersApi(_axios),
          ghgMetrics: ghgMetricsApis(_axios),
        },
      },
    }
  },
})
